import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


const ProtectedRoute = ({ element }) => {
  const { authState } = useAuth();
  const { isAuthenticated, loading } = authState;
  const location = useLocation()

  if (loading) {
    return null; // or a loading indicator
  }

  if (!isAuthenticated) {
    // Redirect to login page, preserving the intended location
    console.log("NOT AUTHEN")
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return element; // Render the component only if authenticated
};

export default ProtectedRoute;
